import React from 'react'
import acceptedFields from '../acceptedFields'
import PropTypes from 'prop-types'

const ContactField = ({ field, fields }) => {
    const Field = fields[field]
    if (Field) {
        return <Field />
    }
    return null
}

ContactField.propTypes = {
    field: PropTypes.string,
    fields: PropTypes.object,
}

ContactField.defaultProps = {
    field: null,
    fields: acceptedFields,
}

export default ContactField
